export const sip_account = {
  modal: {
    remove: {
      content: `Apakah Anda yakin ingin menghapus akun SIP <b>{name}<b>?`
    }
  },

  table: {
    field: {
      login: 'Login',
      host: 'Host',
      password: 'Password',
      internal_number_id: 'Nomor Internal',
      caller_id: 'Nomor External'
    }
  },

  form: {
    title: {
      edit: {
        main: 'Data akun SIP',
        in_phone: 'PBX nomor ekstensi',
        out_phone: 'PBX nomor keluar'
      }
    },

    field: {
      name: 'Nama',
      login: 'Login',
      password: 'Password',
      host: 'Host',
      in_phone: 'Nomor Ekstensi',
      out_phone: 'Nomor Keluar',
      wrtc: 'Dukungan webRTC'
    },

    tooltips: {
      login: 'Login dibuat secara otomatis',
      password: 'Password dibuat secara otomatis'
    }
  }
};
